"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Environment_1 = require("../../Enum/Environment");
const services_1 = require("../../services");
const PXWidgetFacade_1 = require("../../Extendables/PXWidgetFacade");
const TemplateInitializer_1 = require("../../Plugin/WidgetInitializer/TemplateInitializer");
const TooltipExtension_1 = require("../../Plugin/WidgetExtension/TooltipExtension");
const InputJumpExtension_1 = require("../../Plugin/WidgetExtension/InputJumpExtension");
const FormattedNumberComponent_1 = require("../../Plugin/RenderComponent/FormattedNumberComponent");
const PriceComponent_1 = require("../../Plugin/RenderComponent/PriceComponent");
const LoaderRenderComponent_1 = require("../../Plugin/RenderComponent/LoaderRenderComponent");
const TestingExtension_1 = require("../Selector/Plugin/WidgetExtension/TestingExtension");
const PXWidgetTestingFacade_1 = require("../../Extendables/PXWidgetTestingFacade");
const InchcapeBaseEvents_1 = require("../../Enum/InchcapeBaseEvents");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
const FacadeEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/FacadeEvents");
const AppBuilder_1 = require("auto-widget-framework/src/Builder/AppBuilder");
const ViewWidgetConfig_1 = require("./Extandables/ViewWidgetConfig");
const ViewWidgetState_1 = require("./Extandables/ViewWidgetState");
const ValuationDisplayStep_1 = require("./Plugin/WidgetStep/ValuationDisplayStep");
const InchcapeViewEvents_1 = require("./Enum/InchcapeViewEvents");
const configs_1 = require("../../configs/configs");
const ValuationInitializer_1 = require("./Plugin/WidgetInitializer/ValuationInitializer");
const ServiceAlterCompilerPass_1 = require("../../CompilerPass/ServiceAlterCompilerPass");
const DateComponent_1 = require("../../Plugin/RenderComponent/DateComponent");
class ViewBundler {
    static bundle(env) {
        let app = new AppBuilder_1.default()
            .addServices(services_1.services)
            .addCompilerPass(new ServiceAlterCompilerPass_1.default())
            // Compiler passes.
            .addCompilerPass(new ServiceAlterCompilerPass_1.default())
            // Container params.
            .addParameter("load_templates", configs_1.configs.loadTemplates.view)
            // Set extensions.
            .setExtended("widget_config", ViewWidgetConfig_1.default)
            .setExtended("widget_state", ViewWidgetState_1.default)
            .setExtended("widget_facade", PXWidgetFacade_1.default)
            // Add initializer plugins.
            .addPlugin(TemplateInitializer_1.TemplateInitializerDefinition)
            .addPlugin(ValuationInitializer_1.ValuationInitializerDefinition)
            // Add steps.
            .addPlugin(ValuationDisplayStep_1.ValuationDisplayStepDefinition)
            // Add widget extensions.
            .addPlugin(TooltipExtension_1.TooltipExtensionDefinition)
            .addPlugin(InputJumpExtension_1.InputJumpExtensionDefinition)
            // Ractive components.
            .addPlugin(FormattedNumberComponent_1.FormattedNumberComponentDefintion)
            .addPlugin(PriceComponent_1.PriceComponentPluginDefintion)
            .addPlugin(LoaderRenderComponent_1.LoaderComponentPluginDefintion)
            .addPlugin(DateComponent_1.DateComponentPluginDefintion);
        if (env === Environment_1.Environment.DEV) {
            // Extensions used for testing purposes. Comment when not needed.
            app.addPlugin(TestingExtension_1.TestingExtensionDefinition)
                .setExtended("widget_facade", PXWidgetTestingFacade_1.default);
        }
        return {
            Events: Object.assign(Object.assign(Object.assign(Object.assign({}, InchcapeBaseEvents_1.InchcapeBaseEvents), InchcapeViewEvents_1.InchcapeViewEvents), WidgetEvents_1.WidgetEvents), FacadeEvents_1.FacadeEvents),
            Widget: app.create(),
        };
    }
}
exports.default = ViewBundler;
